import React, { FC } from 'react';
import cn from 'classnames';
import { useTheme, useMergeClasses, EngineTheme } from '../../../../../../theme';
import SegmentTab from '../SegmentTab/SegmentTab';
import { SegmentTabType } from '../../model/types';
import FullscreenDialogClose from '../../../../../../FullscreenDialog/components/Close/Close';

interface Props {
	classes?: EngineTheme['Shared']['SegmentTabs']['SegmentTabs'];

	title: string;
	activeSegment: string;
	segments: SegmentTabType[];
	scrollToActive?: boolean;
	sticky?: boolean;
	center?: boolean;
	isCompact?: boolean;

	onSegmentClick: (id: string) => void;
	onClose?: () => void;
}

const SegmentTabs: FC<Props> = ({
	classes,

	title,
	segments,
	activeSegment,

	sticky,
	center,
	scrollToActive,
	isCompact,

	onClose,
	onSegmentClick
}) => {
	const { SegmentTabs: defaultClasses } = useTheme('Shared').SegmentTabs;
	const css = useMergeClasses(defaultClasses, classes);

	const handleSegmentClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (scrollToActive) {
			e.currentTarget?.scrollIntoView({ inline: 'center', block: 'center' });
		}
	};

	return (
		<div
			className={cn(css.wrapper, {
				[css.wrapper_sticky]: sticky,
				[css.wrapper_center]: center,
				[css.wrapper_withClose]: onClose
			})}
		>
			<div id="segment-tabs" className={css.inner}>
				{title && <div className={css.title}>{title}</div>}

				<div className={css.segments}>
					{segments.map((segment, index) => (
						<div key={segment.id} onClick={handleSegmentClick}>
							<SegmentTab
								index={index + 1}
								isActive={segment.id === activeSegment}
								isCompact={isCompact ?? segments.length > 2}
								onClick={() => onSegmentClick(segment.id)}
								segment={segment}
								count={segment.countSeatsSelected}
							/>
						</div>
					))}
				</div>

				{onClose && <FullscreenDialogClose onClose={onClose} closeClassName={css.close} />}
			</div>
		</div>
	);
};

export default SegmentTabs;
